import { invoiceRequest } from '@/services'
import { setWebCache } from '@/utils/basicUtil.js'
import { Notify } from 'vant'

export default {
  namespaced: true,
  state: {
    qrcodeUrl: ``,
    authenticationId: '',
    certificationResults: {}
  },
  mutations: {
    setQrCodeUrl (state, qrcodeUrl) {
      state.qrcodeUrl = qrcodeUrl
    },
    setAuthenticationId (state, authenticationId) {
      state.authenticationId = authenticationId
    },
    setCertificationResults (state, certificationResults) {
      state.certificationResults = certificationResults
    }
  },
  actions: {
    async getQrCode ({ commit }, { refreshType = 0, faceQrCodeType = 0 }) {
      await commit('setQrCodeUrl', '')
      const res = await invoiceRequest.allElectricQrCode.getQrcode({ refreshType, faceQrCodeType })
      if (res.success) {
        await commit('setQrCodeUrl', res.result.ewm || '1')
        await commit('setAuthenticationId', res.result.authenticationId || '3')
        await commit('setCertificationResults', res.result || {})
        setWebCache('faceQrCodeType', faceQrCodeType)
      } else {
        Notify({ type: 'danger', message: res.message })
        return true
      }
    },
    async getAuthInfo ({ commit }) {
      const res = await invoiceRequest.allElectricLogin.getAuthInfo({})
      if (res.success) {
        await commit('setCertificationResults', res.result || {})
      } else {
        Notify({ type: 'danger', message: res.message })
      }
    },
    async getResult ({ commit, state }, { faceQrCodeType = 0 }) {
      const res = await invoiceRequest.allElectricQrCode.getAuthResult({
        faceQrCodeType,
        authenticationId: state.authenticationId
      })
      if (res.success) {
        await commit('setCertificationResults', {
          ...state.certificationResults,
          authenticationResult: res.result || ''
        })
      } else {
        Notify({ type: 'danger', message: res.message })
      }
    }
  }
}
